import { render, staticRenderFns } from "./MarketRatesMap.vue?vue&type=template&id=134fc400&"
import script from "./MarketRatesMap.vue?vue&type=script&lang=js&"
export * from "./MarketRatesMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports